///<reference path='../typings/index.d.ts' />
///<reference path='manifest/assets.ts' />


module agi.expressions.card {
    import AssetManifest = agi.expressions.card.manifest.AssetManifest;

    export class Menu extends PIXI.Container{

        protected menuMuteSoundButton:string;
        protected openMenuContainer:PIXI.Container;
        protected menu:PIXI.Container;
        protected closeTimeline:TimelineMax;
        protected openTimeline:TimelineMax;

        public replayButton:PIXI.Sprite;
        public closeButton:PIXI.Sprite;
        public openButton:PIXI.Sprite;
        public muteButton:PIXI.Sprite;
        public unMuteButton:PIXI.Sprite;
        public fullscreenCloseButton:PIXI.Sprite;
        public sendButton:PIXI.Sprite;
        public animating:boolean = false;
        public isOpen:boolean = false;

        constructor(
                    protected assetManifest:AssetManifest,
                    protected ButtonDownHandler:Function,
                    protected ButtonUpHandler:Function
                   )
        {
            super();
            this.menu = this.createMenu();
            this.addChild(this.menu);
        }

        public openMenu(){
            this.animating = true;
            this.openMenuAnimation();
            this.isOpen = true;
        }

        public closeMenu(){
            this.animating = true;
            this.closeMenuAnimation();
        }

        public showSend(){
            this.sendButton = PIXI.Sprite.fromFrame(this.assetManifest.menuAssets.sendButton);
            this.sendButton.interactive = true;
            this.sendButton.buttonMode = true;
            this.sendButton.on("touchstart", this.ButtonDownHandler, this);
            this.sendButton.on("mousedown", this.ButtonDownHandler, this);
            this.sendButton.position.y = this.openMenuContainer.height - 20;
            this.sendButton.position.x = this.sendButton.width;
            this.openMenuContainer.addChild(this.sendButton);
        }

        public toggleMute(){
            if (this.muteButton.visible){
                this.muteButton.visible = false;
                this.unMuteButton.visible = true;
            }
            else{
                this.muteButton.visible = true;
                this.unMuteButton.visible = false;
            }
        }

        //Menu Animation
        private openMenuAnimation():void {
            this.openMenuContainer.visible = true;
            this.openTimeline.clear();
            this.openTimeline.add(
                [
                TweenLite.to(
                    this.openButton, 0.3,
                    {
                     x:this.openButton.width,
                     ease:Bounce.easeOut
                    }
                ),
                TweenMax.staggerTo(
                    this.openMenuContainer.children, 0.2,
                    {x:0, ease:Back.easeIn},0.04
                )
                ]
            );
        }

        private closeMenuAnimation(){
            this.closeTimeline.clear();
            this.closeTimeline.add(
                [
                TweenMax.staggerTo(
                    this.openMenuContainer.children, 0.2,
                    {x:this.muteButton.width, ease:Back.easeOut},0.04
                ),
                TweenLite.to(
                    this.openButton, 0.3,
                    {
                     x:0,
                     ease:Bounce.easeIn
                    }
                )
                ]
            );
        }

        private finishedOpenMenu():void {
            this.animating = false;
            this.openMenuContainer.visible = true;
        }

        private finishedCloseMenu():void {
            this.animating = false;
            this.openMenuContainer.visible = false;
            this.isOpen = false;
        }

        private createMenu():PIXI.Container {
            var menu:PIXI.Container = new PIXI.Container();
            this.openMenuContainer = new PIXI.Container();
            this.openButton = PIXI.Sprite.fromFrame(this.assetManifest.menuAssets.openButton);
            this.openButton.interactive = true;
            this.openButton.buttonMode = true;
            this.openButton.on("touchstart", this.ButtonDownHandler, this);
            this.openButton.on("touchend", this.ButtonUpHandler, this);
            this.openButton.on("mousedown", this.ButtonDownHandler, this);
            this.openButton.on("mouseup", this.ButtonUpHandler, this);
            this.closeButton= PIXI.Sprite.fromFrame(this.assetManifest.menuAssets.closeButton);
            this.closeButton.interactive = true;
            this.closeButton.buttonMode = true;
            this.closeButton.on("touchstart", this.ButtonDownHandler, this);
            this.closeButton.on("touchend", this.ButtonUpHandler, this);
            this.closeButton.on("mousedown", this.ButtonDownHandler, this);
            this.closeButton.on("mouseup", this.ButtonUpHandler, this);
            this.closeButton.position.x = this.closeButton.width;
            this.openMenuContainer.addChild(this.closeButton);
            this.replayButton = PIXI.Sprite.fromFrame(this.assetManifest.menuAssets.replayButton)
            this.replayButton.visible = true;
            this.replayButton.interactive = true;
            this.replayButton.buttonMode = true;
            this.replayButton.on("touchstart", this.ButtonDownHandler, this);
            this.replayButton.on("touchend", this.ButtonUpHandler, this);
            this.replayButton.on("mousedown", this.ButtonDownHandler, this);
            this.replayButton.on("mouseup", this.ButtonUpHandler, this);
            this.replayButton.position.y = this.openMenuContainer.height - 20;
            this.replayButton.position.x = this.replayButton.width;
            this.openMenuContainer.addChild(this.replayButton);
            this.muteButton = PIXI.Sprite.fromFrame(this.assetManifest.menuAssets.muteSoundButton);
            this.muteButton.interactive = true;
            this.muteButton.buttonMode = true;
            this.muteButton.position.y = this.openMenuContainer.height - 20;
            this.muteButton.on("touchstart", this.ButtonDownHandler, this);
            this.muteButton.on("mousedown", this.ButtonDownHandler, this);
            this.muteButton.position.x = this.muteButton.width;
            this.openMenuContainer.addChild(this.muteButton);
            this.unMuteButton = PIXI.Sprite.fromFrame(this.assetManifest.menuAssets.unMuteSoundButton);
            this.unMuteButton.interactive = true;
            this.unMuteButton.buttonMode = true;
            this.unMuteButton.visible = false;
            this.unMuteButton.position.y = this.muteButton.position.y;
            this.unMuteButton.on("touchstart", this.ButtonDownHandler, this);
            this.unMuteButton.on("mousedown", this.ButtonDownHandler, this);
            this.unMuteButton.position.x = this.unMuteButton.width;
            this.openMenuContainer.addChild(this.unMuteButton);
            this.fullscreenCloseButton = PIXI.Sprite.fromFrame(this.assetManifest.menuAssets.fullscreenCloseButton);
            this.fullscreenCloseButton.interactive = true;
            this.fullscreenCloseButton.buttonMode = true;
            this.fullscreenCloseButton.on("touchstart", this.ButtonDownHandler, this);
            this.fullscreenCloseButton.on("mousedown", this.ButtonDownHandler, this);
            this.fullscreenCloseButton.position.y = this.openMenuContainer.height - 20;
            this.fullscreenCloseButton.position.x = this.fullscreenCloseButton.width;
            this.openMenuContainer.addChild(this.fullscreenCloseButton);
            this.openMenuContainer.visible = false;
            menu.addChild(this.openButton);
            menu.addChild(this.openMenuContainer);

            this.closeTimeline = new TimelineMax({onComplete:this.finishedCloseMenu.bind(this)});
            this.openTimeline = new TimelineMax({onComplete:this.finishedOpenMenu.bind(this)});
            return menu;
        }
    }
}
